<template>
    <div id="app" class="wrap" :class="{'is-loading': $store.state.is_loading}">
        <Loading v-show="$store.state.is_loading || $store.state.is_show_loading" :pos="pos" />


        <Header />
        <router-view v-show="!$store.state.is_loading" />
        <Footer v-show="!$store.state.is_loading" />
        <Cart v-show="!$store.state.is_loading" />
        <Search />
        <Cookies v-if="show_cookies && $store.state.cookies" />

    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Loading from "@/components/Loading.vue";
import Cookies from "@/components/Cookies.vue";
import Form from "@/utils/ContactForm";
import Cart from "@/components/Cart.vue";
import Search from "@/components/Search.vue";

export default {
    name: 'app',

    components: {
        Header,
        Footer,
        Loading,
        Cookies,
        Cart,
        Search,
    },

    data() {
        return {
            pos: {
                left: 0,
                top: 0,
            },
            current_scroll_position: 0,
            offset: 1,
            show_cookies: false,
        }
    },

    watch: {
        '$route.params': {
            handler(params) {
                this.updateClass(params);
            },

            immediate: true,
        }
    },

    methods: {
        updateClass(params) {
            this.$store.state.is_loading = true;
            this.$store.state.show_sub_menu = false;
            this.$store.state.is_show_mobile_navi  = false;


            let body_class = '';
            if (typeof this.$route.name === 'string') body_class = 'is-init page-' + this.$route.name;
            if (typeof this.$route.meta === 'string') body_class = ' page-type-' + this.$route.meta + ' ' + body_class;
            document.body.className = body_class;

            if (this.$store.state.disabled_scroll) {
                setTimeout(() => {
                    this.$store.state.disabled_scroll = false;
                }, 100);
            } else if (!this.$route.hash) {
                window.scrollTo(0, 0);
            }

            if (typeof window.ga === 'function') {
                var name = 'send';
                var trackers = window.ga.getAll();
                if (trackers.length !== 0) {
                    var gname = trackers[0].get('name');
                    if (gname !== '' && gname !== 't0') name = gname + '.' + name;
                }

                ga(name, {
                    hitType: 'pageview',
                    page: location.pathname
                });
            }

            setTimeout(() => {
                let forms = document.querySelectorAll('.wpcf7');
                forms.forEach(e => {
                    if (!e.classList.contains('inited')) {
                        let wpcf = new Form(e, window.globals.home_url);
                        wpcf.init();
                    }
                });
            }, 2000);
        },
        onMousemove(e) {
            //  console.log(e)


            this.pos.top = e.y;
            this.pos.left = e.x;
        },
        onScroll () {
            const current_scroll_position = window.pageYOffset || document.documentElement.scrollTop;

            if (current_scroll_position > this.offset) {
                document.body.classList.add('is-sticky');
            } else {
                document.body.classList.remove('is-sticky');
            }

            // if (current_scroll_position < this.offset) {
            //     this.show_header = false;
            //     return;
            // }

            // this.show_header = current_scroll_position < this.last_scroll_position;
            if (current_scroll_position < this.last_scroll_position) {
                document.body.classList.add('show-header');
            } else {
                document.body.classList.remove('show-header');
            }

            this.last_scroll_position = current_scroll_position;
        },
    },

    mounted() {
        if (window.localStorage.getItem('hide_cookies') === null) this.show_cookies = true;
        window.addEventListener('mousemove', this.onMousemove);
        window.addEventListener('scroll', this.onScroll);

        (function(d){
        var s = d.createElement("script");

        s.setAttribute("data-account", "Gzzy7jpTNQ");
        s.setAttribute("src", "https://cdn.userway.org/widget.js");
        (d.body || d.head).appendChild(s);})(document)

    },


}
</script>
<style lang="scss">
    @import "@/assets/sass/fonts";
    @import "@/assets/sass/reset";

    /********* Base */
    $padding: 3rem;

    :root {
        --font: 'KWPlotter', sans-serif;
        --page-width: 100rem;
        --base-size: 1.95rem;
        --large-size: 2.3rem;
        --tiny-size: 1.17rem;
        --small-size: 1.45rem;
        --title-size: 3.7rem;
        --letter-spacing: 0rem;

        --line: .13rem;
        --line-2: .1rem;

        --padding-25: #{$padding * .25};
        --padding-50: #{$padding * .5 };
        --padding-75: #{$padding * .75};
        --padding:    #{$padding};
        --padding-x2: #{$padding * 2};
        --padding-x3: #{$padding * 3};
        --padding-x4: #{$padding * 4};

        --font-color: #000;
        --bg-color: #FFF;
        --light-gray: #E9E9E9;
        --dark-gray: #9A9A9A;

        --signal-green: #256e3a;
        --sand: #ffe9be;
        --red: #8c2c31;
        --orange: #ff5032;
        --gray: #868889;
        --green: #a4c080;
        --blue: #0079c5;
        --yellow: rgb(255,230,0);
        --cloud-blue: #adc5cb;

    }


    input,
    text,
    keygen,
    select,
    button,
    meter,
    progress {
        font-family: var(--font);
    }

    /********* Links */
    a, a:visited, a:active {
        color: var(--font-color);
        outline: none;
        text-decoration: none;
        // transition: color .2s;
        img {
        }
    }

    a:hover {
        text-decoration: underline;
        img {
            transform: scale(1.05);
            text-decoration: none;
        }
        // color: $red;
    }

    input:-webkit-autofill {
        box-shadow: 0 0 0px 1000px white inset;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-weight: normal;
    }

    strong,
    b {
        font-weight: 400;
    }

    i,
    em {
        font-style: italic;
    }

    html {
        -webkit-overflow-scrolling: touch;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        font-size: 1vw;
        background-color: #fff;
    }

    @media only screen and (min-width: 1270px) {
        html {
            font-size: 13px;
        }
    }

    @media only screen and (min-width: 1500px) {
        html {
            font-size: 15px;
        }
    }

    // @media only screen and (min-width: 1600px) {
    //     html {
    //         font-size: 15px;
    //     }
    // }

    html body {
        font-family: var(--font);
        color: var(--font-color);

        /* Font smoothing */
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-size: var(--base-size);
        min-height: 100vh;
        line-height: 1.25;
        background-color: var(--theme-color-bg);

        &.loading,
        &.loading * {
            cursor: none;
        }

        .uwy.userway_p1 .uai {
            // top: var(--padding-75) !important;
            bottom: var(--padding-75) !important;
            right: var(--padding) !important;
            transform: unset !important;
            position: fixed !important;
        }

        .uwy, body .uwy {
            z-index: 90001 !important;
        }

    }

    i, em {
        font-style: normal;
    }

    .userway_buttons_wrapper {
        transform: none !important;
    }

    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .3s ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .wrap {
        min-height: 100vh;
        display: grid;
        grid-template-rows: auto 1fr auto;
        grid-template-columns: 100%;

        &.is-loading,
        &.is-loading * {
            cursor: none;
        }
    }

    .page-inner {
        width: 100%;
        box-sizing: border-box;
        // max-width: var(--page-width);
        margin-left: auto;
        margin-right: auto;
    }



    .page-wrap {
        width: var(--page-size);
        padding: 0 var(--padding);

        margin-left: auto;
        margin-right: auto;
        padding-bottom: var(--padding-x2);

        .page-title {
            margin: var(--padding) 0;
            font-size: var(--title-size);
            line-height: 1.2;
        }
    }

    .page-type-page {
        .page-title {
            font-size: var(--large-size);
            margin: 0 0 var(--padding-50);
        }
    }

    input[type=checkbox] {
        display: block !important;
        position: absolute;
        cursor: pointer;
        opacity: 0;
        -webkit-appearance: unset;
        z-index: 3;
    }

    input[type=checkbox] + span:before {
        content: "";
        display: inline-block;
        width: 1.3rem;
        height: 1.3rem;
        margin: -0.1rem .5rem 0 0;
        vertical-align: middle;
        cursor: pointer;
        -moz-border-radius: 50%;
        border-radius: 50%;
        border: var(--line-2) solid #000;
    }

    input[type=checkbox]:checked + span:before {
        background-color: #000;
    }

    .custom-button {
        display: inline-block;
        box-sizing: border-box;
        border: var(--line-2) solid;
        font-size: var(--base-size);
        padding: .3rem 1.2rem;
        line-height: 1;
    }

    .woocommerce *{
        font-weight: normal !important;
        font-weight: unset !important;
        p a {
            border-bottom: var(--line-2) solid;
        }
    }

    .woocommerce form .form-row input.input-text,
    .woocommerce form .form-row textarea {
        padding: var(--padding);
        border: var(--line-2) solid var(--gray);

        &:focus {
            border-color: black;
        }
    }

    .woocommerce-account .woocommerce-MyAccount-navigation {
        float: none;
        width: auto;

        ul {
            display: flex;

            a {
                display: block;
                height: 4.2rem;
                line-height: 4.26rem;
                padding: 0 2rem;
            }

            .is-active a {
                background: var(--gray);
            }

            .woocommerce-MyAccount-navigation-link--customer-logout {
                flex: 1;
                text-align: right;

                a {
                    display: inline-block;
                }
            }
        }
    }

    .woocommerce-account .woocommerce-MyAccount-content {
        padding: var(--padding) 0;
        float: none;
        width: auto;
    }

    .woocommerce .col2-set,
    .woocommerce-page .col2-set {
        margin: var(--padding-x2) 0;
    }

    .woocommerce form .show-password-input, .woocommerce-page form .show-password-input {
        top: auto;
    }

    .woocommerce-info {
        border-top: black;
        &::before {
            color: black;
        }
    }

    .woocommerce #respond input#submit.alt, .woocommerce a.button.alt, .woocommerce button.button.alt, .woocommerce input.button.alt {
        background-color: black;
    }

    .woocommerce #respond input#submit.alt:hover, .woocommerce a.button.alt:hover, .woocommerce button.button.alt:hover, .woocommerce input.button.alt:hover {
        background-color: var(--dark-gray);
    }

    .woocommerce form .form-row .select2-container {
        line-height: 5rem;
    }

    .select2-container .select2-selection--single {
        height: 5rem;
    }

    .select2-container--default .select2-selection--single .select2-selection__rendered {
        line-height: 5rem;
    }

    .select2-container .select2-selection--single .select2-selection__rendered {
        padding-left: var(--padding);
        padding-right: var(--padding);
    }

    .select2-container--default .select2-selection--single .select2-selection__arrow {
        width: 5rem;
        height: 5rem;
    }

    .select2-container--default .select2-results__option--highlighted[aria-selected], .select2-container--default .select2-results__option--highlighted[data-selected] {
        background-color: black;
    }

    .woocommerce form .form-row textarea {
        height: 10em;
    }

    .wpcf7-list-item {
        margin-left:0;
        margin-right: 0;
    }

    @media only screen and (max-width: 767px) {
        $padding: 5rem;

        :root {
            --page-width: 100%;
            --base-size: 5rem;
            --large-size: 6rem;
            --tiny-size: 4rem;
            --small-size: 4rem;
            --title-size: 8rem;
            --letter-spacing: 0rem;

            --line: .4rem;
            --line-2: .4rem;

            --padding-25: #{$padding / 4};
            --padding-50: #{$padding / 2};
            --padding:    #{$padding};
            --padding-x2: #{$padding * 2};
            --padding-x3: #{$padding * 3};
            --padding-x4: #{$padding * 4};

        }

        .wrap {
            padding-top: var(--padding);
        }

        html body .uwy.userway_p1 .uai {
            top: unset !important;
            bottom: var(--padding-x2) !important;
            right: var(--padding-50) !important;
            transform: unset !important;
        }

        html body .uwy {
            z-index: 90001 !important;
        }

        body .uwy.umb .uai .uhi {
            display: none !important;
        }

    }
</style>
